import { all, call, put, select, takeLeading } from "redux-saga/effects";

import { State } from "store/types";

import Mekong from "lib/ajax/Mekong";
import {
	FeedClippingSort,
	ReportDefinition,
	ReportFeedClipping,
	resetReport,
	setReportError,
	setSaveReportModalOpen
} from "./reducers";
import { ToastService } from "@launchmetrics/lm-ui";
import { t } from "lib/i18n";
import { push } from "connected-react-router";
import { store } from "store";


const WRONG_PARAMS_ERROR = 'reports.side_panel.save_modal.input.error.wrong_params';
const NAME_ALREADY_EXISTS_ERROR ='reports.side_panel.save_modal.input.error.report_name';

export default function* sagas() {
	yield all([
		takeLeading('report/saveReport', saveReport)
	]);
}

function* saveReport() {
	const name: string = yield select((state: State) => state.article.report.configuration.name);
	if (!name.trim()) {
		yield put(setReportError(WRONG_PARAMS_ERROR));
		return;
	}

	const definition: ReportDefinition = yield select((state: State) => state.article.report.configuration.definition);
	const feeds: string[] = yield select((state: State) => state.search.filters.feeds);

	const sortBy: string = yield select((state: State) => state.search.form.sort);
	const feedClippings = definition.feedClippings.map((feedClipping: ReportFeedClipping) =>
		({...feedClipping, sort: sortBy as FeedClippingSort})
	);

	try {
		yield call([Mekong, 'post'], `/v1/report/configuration`, { data: {
			name,
			// TODO GIS-4644 Discuss if the report configuration type should be the current one of powerpoint | excel | online
			type: definition.settings.type,
			definition: {
				...definition,
				feeds,
				feedClippings
			}
		}});

		// TODO GIS-4674 Show success notification
		yield put(setReportError(''));
		yield put(setSaveReportModalOpen(false));
		yield put(resetReport());

		ToastService.show({
			id: 'report-saved-toast',
			title: t('reports.saved_success_title'),
			description: t('reports.saved_success_description'),
			type: 'success',
			duration: 5000,
			action: {
				text: t('reports.saved_success_action'),
				fn: () => {
					store.dispatch(push('/report'));
					ToastService.remove('report-saved-toast');
				}
			}
		});
	} catch (error: unknown) {
		const code = (error as any).code;
		switch (code) {
			case 'WRONG_PARAMETER':
				yield put(setReportError(WRONG_PARAMS_ERROR));
				break;
			case 'NAME_ALREADY_EXISTS':
				yield put(setReportError(NAME_ALREADY_EXISTS_ERROR));
				break;
		}
	}
}
